import dark from './dark';
import light from './light';

const themes: any = {
  dark,
  light,
};

export { dark, light, themes };
